import { i18n } from '../i18nType';

export const OPTIONAL_LABEL: i18n = { en: 'Optional' };
export const CLOSE_LABEL: i18n = { en: 'Close' };
